import Vue from 'vue';
import {
  InfiniteScroll,
  Loading,
  MessageBox,
} from 'element-ui';

import Progress from 'element-ui/lib/progress';
import FormSection from '~/modules/FormSection.vue';
import Notification from './notification';

import ColorPicker from './ColorPickerCustom.vue';
import TwoLineSelect from './TwoLineSelect.vue';
import Anchor from './Anchor.vue';
import Button from './Button.vue';
import Column from './Column.vue';
import Dropdown from './Dropdown.vue';
import DateSelect from './DateSelect.vue';
import DropdownItem from './DropdownItem.vue';
import DropdownMenu from './DropdownMenu.vue';
import Form from './Form.vue';
import FormGroup from './FormGroup.vue';
import Heading from './Heading.vue';
import NumericInputCustom from './NumericInputCustom.vue';
import Option from './Option.vue';
import Popover from './Popover.vue';
import Radio from './Radio.vue';
import RadioGroup from './RadioGroup.vue';
import Row from './Row.vue';
import Select from './Select.vue';
import SelectDialog from './selectDialog';
import Table from './Table.vue';
import TableColumn from './TableColumn.vue';
import TextInput from './TextInput.vue';
import Tooltip from './Tooltip.vue';
import WhiteContainer from './WhiteContainer.vue';
import Drawer from './Drawer.vue';

import VMoney from './money/directive';

Vue.directive('money', VMoney);

Vue.use(InfiniteScroll);
Vue.use(Loading.directive);
Vue.use(SelectDialog);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$notify = Notification;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;

Vue.component('CollapseTransition', () => import(/* webpackChunkName: "ui-components" */'element-ui/lib/transitions/collapse-transition'));
Vue.component('ContainerWrapper', () => import(/* webpackChunkName: "ui-components" */'~/modules/layout/ContainerWrapper.vue'));
Vue.component('TableHeading', () => import(/* webpackChunkName: "ui-components" */'~/modules/TableHeading.vue'));
Vue.component('CountryField', () => import(/* webpackChunkName: "ui-components" */'~/components/Common/CountryField.vue'));

Vue.component('Anchor', Anchor);
Vue.component('TwoLineSelect', TwoLineSelect);
Vue.component('Button', Button);
Vue.component('ColorPicker', ColorPicker);
Vue.component('Column', Column);
Vue.component('DateSelect', DateSelect);
Vue.component('Drawer', Drawer);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownItem', DropdownItem);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('Form', Form);
Vue.component('FormGroup', FormGroup);
Vue.component('FormSection', FormSection);
Vue.component('Heading', Heading);
Vue.component('InfiniteScroll', InfiniteScroll);
Vue.component('NumericInputCustom', NumericInputCustom);
Vue.component('Option', Option);
Vue.component('Popover', Popover);
Vue.component('Progress', Progress);
Vue.component('Radio', Radio);
Vue.component('RadioGroup', RadioGroup);
Vue.component('Row', Row);
Vue.component('Select', Select);
Vue.component('Table', Table);
Vue.component('TableColumn', TableColumn);
Vue.component('TextInput', TextInput);
Vue.component('Tooltip', Tooltip);
Vue.component('WhiteContainer', WhiteContainer);

const customComponents = {
  Alert: './Alert.vue',
  Autocomplete: './Autocomplete.vue',
  BooleanSelect: './BooleanSelect.vue',
  ButtonGroup: './ButtonGroup.vue',
  ButtonHolder: './ButtonHolder.vue',
  Card: './Card.vue',
  Checkbox: './Checkbox.vue',
  CheckboxGroup: './CheckboxGroup.vue',
  ContentLoader: './ContentLoader.vue',
  DatePicker: './DatePicker.vue',
  Dialog: './Dialog.vue',
  Divider: './Divider.vue',
  EditableSelect: './EditableSelect.vue',
  IconBox: './IconBox.vue',
  InputHelp: './InputHelp.vue',
  NumericInput: './NumericInput.vue',
  Pagination: './Pagination.vue',
  Tag: './Tag.vue',
  ToggleSwitch: './Switch.vue',
  Upload: './Upload.vue',
};

Object.entries(customComponents).forEach(([name, path]) => {
  Vue.component(name, () => import(/* webpackChunkName: "ui-components" */`${path}`));
});
